import { FC, useEffect, useState } from 'react';
import { Divider, Tabs, Typography } from 'antd';
import { LucideKeyRound } from 'lucide-react';
import { TbBrowserCheck, TbWebhook } from 'react-icons/tb';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { LearnMoreFooter } from '@/shared';

import Metadata from './meta';
import APIKeys from './routes/01-APIKeys';
import Webhooks from './routes/02-Webhooks';
import OAuthApplications from './routes/03-OAuthApplications';

// interface DevelopersProps {}

const Developers: FC = (): JSX.Element => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
    }, []);

    const { token } = useAntDesignTheme();

    const url = '/settings/workspace/developers';

    const items = [
        {
            label: (
                <>
                    <LucideKeyRound size='0.875rem' style={{ verticalAlign: '-0.1rem', marginRight: '0.375rem' }} />
                    API Keys
                </>
            ),
            key: 'api',
            children: <APIKeys />,
        },
        {
            label: (
                <>
                    <TbWebhook size='1rem' style={{ verticalAlign: '-0.15rem', marginRight: '0.375rem' }} />
                    Webhooks
                </>
            ),
            key: 'webhooks',
            children: <Webhooks />,
        },
        {
            label: (
                <>
                    <TbBrowserCheck size='1rem' style={{ verticalAlign: '-0.15rem', marginRight: '0.375rem' }} />
                    OAuth Applications
                </>
            ),
            key: 'applications',
            children: <OAuthApplications />,
        },
    ];

    const activeKey = location.pathname.split('/')[4];

    const navigate = useNavigate();

    const onChangeTab = (newActiveKey: string) => {
        navigate(`${url}/${newActiveKey}`);
    };

    return (
        <>
            <Metadata />
            <Typography.Title level={1}>Developers</Typography.Title>
            <Typography.Paragraph style={{ color: token.colorTextTertiary }}>
                See and update your developer resources here.
            </Typography.Paragraph>
            <Routes>
                <Route index element={<Navigate to={`${url}/api`} replace />} />
                <Route path='oauth' element={<Navigate to={`${url}/applications`} replace />} />
                <Route
                    path='*'
                    element={<Tabs items={items} animated={true} activeKey={activeKey} size='small' onChange={onChangeTab} />}
                />
            </Routes>
            <Divider style={{ marginTop: '0.75rem' }} />
            <LearnMoreFooter
                href='https://docs.countercyclical.io/developers/getting-started'
                topic='our API, Webhooks, and OAuth Applications'
            />
        </>
    );
};

export default Developers;
